export default __webpack_public_path__ + "static/media/cornar.35915aa9.svg";